const PublicKeyTypes = [
  { key: "public_website_map_key", text: "Public Website Map Key" },
]

export { PublicKeyTypes }